import React from 'react';
import CustomBadge from './CustomBadge';

interface Props {
	children: React.ReactNode;
	type: 'success' | 'error' | 'warning' | 'info' | 'primary' | 'default';
}

const Badge = ({ type, children }: Props) => {
	let bgColor: string | undefined;

	switch (type) {
		case 'primary':
			bgColor = 'var(--primary-color)';
			break;
		case 'info':
			bgColor = 'var(--info-color)';
			break;

		case 'success':
			bgColor = 'var(--success-color)';
			break;

		case 'warning':
			bgColor = 'var(--warning-color)';
			break;

		case 'error':
			bgColor = 'var(--error-color)';
			break;
		case 'default':
			bgColor = '#777';
			break;
	}

	return (
		<CustomBadge bgColor={bgColor} textColor="white">
			{children}
		</CustomBadge>
	);
};

export default Badge;
